
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import MiniCartContainer from './Columbus/Containers/MiniCart.container';
import QuickSearchContainer from './Columbus/Containers/QuickSearch.container';
import NavigationContainer from './Containers/Navigation.container';
import FacetedSearchContainer from './Containers/FacetedSearch.container';
import FacetedSearchCompactContainer from './Columbus/Containers/FacetedSearchCompact.container';

import DynamicComponent from './Components/DynamicComponent';
import { translate } from './Services/translation';
import { get, post } from './Services/http';
 
// COLUMBUS 
import './columbus.events.js'; 
window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
// use the parent page's store if possible, so the iframe will share the same store with the parent context.
// this to makes for example the Reorder button in My Page page to update the state and reload the mini cart
// when reorder action happens.
const store = window.__litium.store = window.__litium.store || (document.getElementById('orderTab') && window.parent.__litium && window.parent.__litium.store)
    || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));
window.__litium = {
    ...window.__litium,
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
    registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
}

window.onpagehide = (event) => {
    if (!event.persisted) {
        // make sure components are unmounted, redux's listener are unsubscribed
        // to fix issue with iframe navigation in IE
        registeredContainers.forEach(container => {
            ReactDOM.unmountComponentAtNode(container);
        });
    }
}
let BuyButton = null;
let ProductQuantity = null;

const bootstrapComponents = () => {
    const miniCartEls = document.querySelectorAll('.mini-cart-top');
    if (miniCartEls) {
        Array.from(miniCartEls).forEach((miniCart) => {
            renderReact(<Provider store={store}>
                <MiniCartContainer />
            </Provider>,
                miniCart
            );
        });
    }

    const quickSearchContainers = document.querySelectorAll('.header__quick-search');
    if (quickSearchContainers) {
        Array.from(quickSearchContainers).forEach((quickSearch) => {
            renderReact(<Provider store={store}>
                <QuickSearchContainer />
            </Provider>,
                quickSearch
            );
        });
    }

    const navBar = document.getElementById('navbar');
    if (navBar) {

        const myPageUrl = navBar.dataset.myPageUrl;
        const myPageText = navBar.dataset.myPageText;
        renderReact(
            <Provider store={store}>
                <NavigationContainer myPageUrl={myPageUrl} myPageText={myPageText} />
            </Provider>,
            navBar
        );
    }
    const facetedSearch = document.getElementById('facetedSearch');
    if (facetedSearch) {
        renderReact(
            <Provider store={store}>
                <FacetedSearchContainer />
            </Provider>,
            facetedSearch
        );
    }
    const facetedSearchCompactEl = document.getElementById('facetedSearchCompact');
    if (facetedSearchCompactEl) {
        const showCompactForDesktop = facetedSearchCompactEl.dataset.showDesktop;
        renderReact(
            <Provider store={store}>
                <FacetedSearchCompactContainer showCompactForDesktop={showCompactForDesktop} />
            </Provider>,
            facetedSearchCompactEl
        );
    }
    const myPagePersons = document.getElementById('myPagePersons');
    if (myPagePersons) {
        const PersonList = DynamicComponent({
            loader: () => import('./Columbus/Containers/PersonList.container')
        });
        renderReact(
            <Provider store={store}>
                <PersonList />
            </Provider>,
            myPagePersons
        );
    }
    const myPageMonitors = document.getElementById('myPageMonitors');
    if (myPageMonitors) {
        const MonitorList = DynamicComponent({
            loader: () => import('./Columbus/Containers/MonitorList.container')
        });
        renderReact(
            <Provider store={store}>
                <MonitorList />
            </Provider>,
            myPageMonitors
        );
    }

    const myPageAddresses = document.getElementById('myPageAddresses');
    if (myPageAddresses) {
        const AddressList = DynamicComponent({
            loader: () => import('./Columbus/Containers/AddressList.container')
        });
        renderReact(
            <Provider store={store}>
                <AddressList />
            </Provider>,
            myPageAddresses
        );
    }

    const checkout = document.getElementById('checkout');
    if (checkout) {
        const Checkout = DynamicComponent({
            loader: () => import('./Columbus/Containers/Checkout.container')
        });
        renderReact(
            <Provider store={store}>
                <Checkout />
            </Provider>,
            checkout
        );
    }
    const lightBoxImages = document.getElementById('lightBoxImages');
    if (lightBoxImages) {
        lightBoxImages.style.height = lightBoxImages.offsetHeight + "px";

        const LightboxImages = DynamicComponent({
            loader: () => import('./Containers/LightboxImages.container')
        });
        const images = Array.from(lightBoxImages.querySelectorAll('a')).map(img => ({ 
            src: img.dataset.src,
            tagIsNew: img.dataset.tagIsNew,
            tagDiscountText: img.dataset.tagDiscountText,
            tagDiscountColor: img.dataset.tagDiscountColor,
            height: img.firstElementChild.getAttribute("height"),
            width: img.firstElementChild.getAttribute("width")
            }));
        const thumbnails = Array.from(lightBoxImages.querySelectorAll('a img')).map(img => ({ src: img.src, alt: img.alt }));
        renderReact(
            <Provider store={store}>
                <LightboxImages images={images} thumbnails={thumbnails} />
            </Provider>,
            lightBoxImages
        );
        setTimeout(function () { document.getElementById('lightBoxImages').style.height='' },500);
    }

    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Columbus/Components/Slider')
        });
        Array.from(document.querySelectorAll('.slider')).forEach((slider) => {
            const values = [...slider.querySelectorAll('.slider__block')].map(block => {
                return ({
                    image: block.dataset.image,
                    url: block.dataset.url,
                    text: block.dataset.text,
                })
            });
            if (values.length > 0) {
                renderReact(
                    <Slider values={values} />,
                    slider
                );
            }
        });
    }

    const buyButtons = document.querySelectorAll('buy-button');
    if (buyButtons.length > 0) {
        BuyButton = DynamicComponent({
            loader: () => import('./Columbus/Containers/BuyButton.Container')
        });

        Array.from(buyButtons).forEach((button) => {
            initBuyButton(button)
        });
    }

    // Listen to tab clicks on PDP
    const productInfoTabs = document.querySelectorAll('.product-info__container .tab__header');
    if (productInfoTabs.length > 0) {
        const ProductInfoTab = DynamicComponent({
            loader: () => import('./Columbus/Containers/ProductInfoTab.container')
        });
        Array.from(productInfoTabs).map((tabLabel) => {
            const { tabType, title, explodedViewImgCount } = tabLabel.dataset;

            ReactDOM.render(
                <Provider store={store}>
                    <ProductInfoTab {...{ tabType, title, explodedViewImgCount }} />
                </Provider>,
                tabLabel
            );
        });
    }
    const monitorButtons = document.querySelectorAll('monitor-button');
    if (monitorButtons.length > 0) {
        const MonitorButton = DynamicComponent({
            loader: () => import('./Columbus/Containers/MonitorButton.Container')
        });
        Array.from(monitorButtons).forEach((button) => {
            const { articleNumber, cssClass, label } = button.dataset;
            const isTopButton = cssClass.indexOf("top-button") >= 0;
            renderReact(
                <Provider store={store}>
                    <MonitorButton {...{ label, articleNumber, cssClass, isTopButton}} />
                </Provider>,
                button
            );
        });
    }
    const sellerButtons = document.querySelectorAll('seller-button');
    if (sellerButtons.length > 0) {
        const SellerButton = DynamicComponent({
            loader: () => import('./Columbus/Containers/SellerButton.container')
        });
        Array.from(sellerButtons).forEach((button) => {
            const { articleNumber, quantityFieldId, cssClass, label } = button.dataset;
            const isTopButton = cssClass.indexOf("top-button") >= 0;
            renderReact(
                <Provider store={store}>
                    <SellerButton {...{ label, articleNumber, quantityFieldId, cssClass, isTopButton }} />
                </Provider>,
                button
            );
        });
    }
    const reorderButtons = document.querySelectorAll('reorder-button');
    if (reorderButtons.length > 0) {
        const ReorderButton = DynamicComponent({
            loader: () => import('./Columbus/Containers/ReorderButton.Container')
        });
        Array.from(reorderButtons).forEach((button) => {
            const { cssClass, orderId, title } = button.dataset;
            const label = button.innerText;
            renderReact(
                <Provider store={store}>
                    <ReorderButton {...{ label, title, cssClass, orderId }} />
                </Provider>,
                button
            );
        });
    }

    const productQuantityEl = document.querySelectorAll('.product__quantity-container');
    if (productQuantityEl.length > 0) {
        ProductQuantity = DynamicComponent({
            loader: () => import('./Columbus/Containers/ProductQuantity.Container')
        });
        Array.from(productQuantityEl).forEach((productQuantity) => {
            initQuantity(productQuantity);
        });
    }
    const columbusModalEl = document.querySelectorAll('.columbus-modal');
    if (columbusModalEl) {
        const ColumbusModal = DynamicComponent({
            loader: () => import('./Columbus/Components/ColumbusModal')
        });
        Array.from(columbusModalEl).forEach((columbusModal) => {
            const modalText = columbusModal.innerHTML;
            const { modalLinkText } = columbusModal.dataset;
            renderReact(
                <Provider store={store}>
                    <ColumbusModal {...{ modalText, modalLinkText }} />
                </Provider>,
                columbusModal
            );
        });
    }


    const cookieBar = document.getElementById('cookieBar');
    if (cookieBar) {
        const CookieWarning = DynamicComponent({
            loader: () => import('./Columbus/Components/CookieBar')
        });
        renderReact(
            <Provider store={store}>
                <CookieWarning {...{cookiebarVisible:true}} />
            </Provider>,
            cookieBar
        )
    }

    const cookieButton = document.getElementById('cookieButton');
    if (cookieButton) {
        const CookieSettings = DynamicComponent({
            loader: () => import('./Columbus/Components/CookieBar')
        });
        const { functional, analytics, marketing, personalization } = cookieButton.dataset;
        renderReact(
            <Provider store={store}>
                <CookieSettings {...{showButton:true, functional, analytics, marketing, personalization}} />
            </Provider>,
            cookieButton
        )
    }

    // Newsletter signup
    const newsletterSignup = document.getElementById('newsletterSignup');
    if (newsletterSignup) {
        const NewsletterSignup = DynamicComponent({
            loader: () => import('./Columbus/Components/NewsletterSignup')
        })
        ReactDOM.render(
            <Provider store={store}>
                <NewsletterSignup />
            </Provider>,
            newsletterSignup
        );
    }
    
    //Generic export
    const genericExport = document.getElementById('genericExport');
    if (genericExport) {
        const GenericExport = DynamicComponent({
            loader: () => import('./Columbus/Containers/GenericExport.container')
        })
        ReactDOM.render(
            <Provider store={store}>
                <GenericExport />
            </Provider>,
            genericExport
        );
    }

    var exportMenu = document.getElementById('exportmenu');
    if (exportMenu) {
        const ExportMenu = DynamicComponent({
            loader: () => import('./Columbus/Containers/ExportMenu.container')
        })
        ReactDOM.render(
            <Provider store={store}>
                <ExportMenu />
            </Provider>,
            exportMenu
        );
    }

    if (window.__litium.constants.scannerPageUrl)
    {
        const productScanner = document.getElementById('productScanner');
        if (productScanner){

            // iPad-fix
            const headerEl = document.querySelector('.header');
            
            if (headerEl) {
                // Old ipad fix
                headerEl.style.position = 'fixed';
            }            

            const ProductScannerpage = DynamicComponent({
                loader: () => import('./Columbus/Containers/ProductScannerPage.container')
            });
            renderReact(
                <Provider store={store}>
                    <ProductScannerpage />
                </Provider>,
                productScanner
            );
        }
        else
        {
            let isInIframe = false;
            try { isInIframe = window.self !== window.top; } catch (e) { isInIframe = true; }

            if (!isInIframe) {
                var anchor = document.createElement('a');
                anchor.setAttribute('href', window.__litium.constants.scannerPageUrl);
                anchor.setAttribute('class', 'back-to-scanner form__button form__button--expand');

                const continueScanninTranslateKey = 'common.productscanner.continuescanning';
                anchor.innerHTML = translate(continueScanninTranslateKey);
                document.body.appendChild(anchor);
            }
        }
    }

    const selectOrganizationEls = document.querySelectorAll('.selectOrganization');
    if (selectOrganizationEls){
        const SelectOrganizationContainer = DynamicComponent({
            loader: () => import('./Columbus/Containers/SelectOrganization.container')
        });
        Array.from(selectOrganizationEls).forEach((selectOrganization) => {
            renderReact(
                <Provider store={store}>
                    <SelectOrganizationContainer />
                </Provider>,
                selectOrganization
            );
        });
    }

    const catnav = document.querySelectorAll('[data-klevu]');
    if (catnav){
        catnav.forEach((box, index) => {
            initKlevuAnalytics(box,index);
        });
    }

    const channelPickers = document.querySelectorAll('.js-channel-url');
    if (channelPickers) {
        Array.from(channelPickers).forEach((channel) => {
            channel.addEventListener('click', function (e) {
                e.preventDefault();
                post('/api/channel/' + channel.dataset.channel).then(() => {
                    location.href = channel.href;
                })
            })
        });
    }

    const klevuProductRecommendation = document.querySelectorAll('.js-klevu-recs');
    if (klevuProductRecommendation != null) {
        klevuProductRecommendation.forEach((rec)=> {
            const ktag = rec.dataset.ktag;
            const kid = rec.dataset.kid;
            fetch(location.href.split("?")[0] + "?ktag=" + ktag + "&kid=" + kid,
            {
                method: 'GET',
                headers: {
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache'
                }
            })
            .then(response => response.text())
            .then(data => {
                rec.innerHTML = '';
                const pageHtml = new DOMParser().parseFromString(data, 'text/html');
                const childNodes = pageHtml.querySelectorAll('li');
                if (childNodes) {
                    for (let elem of childNodes) {
                        elem.classList.add('product-list__item--added');
                    }
                    if (kid==='pdp'){
                        rec.appendChild(pageHtml.querySelector('div'));
                    }
                    else{
                        rec.appendChild(pageHtml.querySelector('ul'));
                    }
                    const newEls = document.querySelectorAll('.product-list__item--added');
                    newEls.forEach((newEl, index) => {
                        initBuyButtons(newEl);
                        initKlevuAnalytics(newEl.querySelector('div'), index)
                    })
                    rec.classList.remove('hiddenblock');
                }
            });
        });
    }

    let data = sessionStorage.getItem('klevu');
    if (data) {
        sessionStorage.removeItem('klevu');
        get(data);
    }
}

function initKlevuAnalytics(wrapperEl, index)
{
    wrapperEl.addEventListener('click', function handleClick(e) {
        const buyButtonClick = e.target.classList.contains('buy-button');
        let req = '';
        let price = ''
        const ul = this.closest('.product-list');
        const searchResult = document.getElementById('search-result');
        const priceProp = this.querySelector('#priceprop');
        if (priceProp) {
            price = priceProp.getAttribute('content');
        }
        if (ul.dataset.klevurec) {
            req = '/api/klevu/recnav?' +
                "t=" + ul.dataset.klevutag +
                "&r=" + ul.dataset.klevurec +
                "&i=" + index +
                "&v=" + this.dataset.klevu +
                "&p=" + price;
            if (buyButtonClick) {
                get(req);
            }
        } else if (window.__litium.requestContext.productCategorySystemId) {
            req = '/api/klevu/catnav?cat=' + window.__litium.requestContext.productCategorySystemId + "&v=" + this.dataset.klevu;
        } else if (searchResult) {
            req = '/api/klevu/quicksearch?v=' + this.dataset.klevu + "&q=" + encodeURIComponent(document.querySelector('.query').innerHTML);
        }
        if (!buyButtonClick) {
            sessionStorage.setItem('klevu', req);
        }
    });
}

function initBuyButtons(wrapperEl) {

    if (!wrapperEl) {
        wrapperEl = document.querySelector('body');
    }

    if (wrapperEl) {
        if (wrapperEl.querySelectorAll('buy-button').length > 0) {
            Array.from(document.querySelectorAll('buy-button')).forEach((button) => {
                initBuyButton(button);
            });
        }
        if (wrapperEl.querySelectorAll('.product__quantity-container').length > 0) {
            Array.from(document.querySelectorAll('.product__quantity-container')).forEach((button) => {
                initQuantity(button);
            });
        }
    }
}
function initBuyButton(buyButton) {
    const { articleNumber, quantityFieldId, href, cssClass, label, inStockQuantity, articleName } = buyButton.dataset;
    const isB2c = cssClass.indexOf('bag') !== -1;
    if (BuyButton==null){
        BuyButton = DynamicComponent({
            loader: () => import('./Columbus/Containers/BuyButton.Container')
        });
    }
    ReactDOM.render(
        <Provider store={store}>
            <BuyButton {...{ label, articleNumber, quantityFieldId, href, cssClass, inStockQuantity, articleName }} isB2c={isB2c} />
        </Provider>,
        buyButton
    );
}
function initQuantity(productQuantity) {
    const { quantityFieldId, multiple, inStockQuantity} = productQuantity.dataset;
    if (ProductQuantity == null){
        ProductQuantity = DynamicComponent({
            loader: () => import('./Columbus/Containers/ProductQuantity.Container')
        });
    }
    renderReact(
        <Provider store={store}>
            <ProductQuantity {...{ quantityFieldId, multiple, inStockQuantity }} />
        </Provider>,
        productQuantity
    );
}
bootstrapComponents();